import { create, test, enforce } from 'vest';

// @ts-ignore
import isEmail from 'validator/lib/isEmail';

enforce.extend({ isEmail });

const validators = create((data = {}) => {
  test('email', 'Email invalid.', () => {
    enforce(data.email).isEmail();
  });
  test('email', 'Email can\'t be empty.', () => {
    enforce(data.email).isNotEmpty();
  });
  test('password', 'Password can\'t be empty.', () => {
    enforce(data.password).isNotEmpty();
  });
  test(
    'password',
    'Password cannot be shorter than 9 characters and longer than 64 characters.',
    () => {
      enforce(data.password).longerThanOrEquals(9).shorterThanOrEquals(64);
    }
  );
});

export default validators;
